exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-js": () => import("./../../../src/pages/[...].js" /* webpackChunkName: "component---src-pages-js" */),
  "component---src-pages-ssr-cache-js": () => import("./../../../src/pages/ssr/cache.js" /* webpackChunkName: "component---src-pages-ssr-cache-js" */),
  "component---src-pages-ssr-no-cache-js": () => import("./../../../src/pages/ssr/no-cache.js" /* webpackChunkName: "component---src-pages-ssr-no-cache-js" */)
}

